import { Component, EventEmitter, Output } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { ServicoService } from 'src/app/services/servico.service';


@Component({
  selector: 'app-servico-exclusao',
  templateUrl: './servico-exclusao.component.html',
  styleUrls: ['./servico-exclusao.component.scss']
})
export class ServicoExclusaoComponent {
  visivel: boolean = false;
  registro: any = {};
  validacoes: string[] = [];

  @Output()
  onSucesso: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private app: AppComponent,
    private servicoService: ServicoService) {
  }

  abrir(registro: any) {
    this.visivel = true;
    this.registro = registro;
  }

  fechar() {
    this.visivel = false;
    this.registro = {};
    this.validacoes = [];
  }

  confirmar() {
    this.app.bloquearTela();
    this.validacoes = [];

    this.servicoService
      .excluir(this.registro.id)
      .subscribe(response => {
        this.app.desbloquearTela();

        if (response.sucesso) {
          this.onSucesso.emit(this.registro);
          this.fechar();
        } else {
          this.validacoes = response.mensagens!;
        }
      });
  }
}